var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-4 mt-md-5"},[_c('ExclamationOctagonIcon',{staticClass:"fs-1 mb-3"}),_c('br'),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }